import {useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";

export const WelcomePanel = () => {
	const [matchId, setMatchId] = useState('')
	const [isStartingGame, setIsStartingGame] = useState(false)
	const navigate = useNavigate();

	const onConnectFormSubmit = (e) => {
		if (isStartingGame) {
			return;
		}

		e.preventDefault();
		setIsStartingGame(true)
		navigate(`/m/${matchId}`)
	}

	const onCreateGameSubmit = () => {
		setIsStartingGame(true)
		const promise = axios.post('api/m/')
			.then(response => {
				navigate(`/m/${response.data.id}`)
			})
			.catch(error => {
				console.error(error);
				setIsStartingGame(false)
			})
	}

	return (
		<div className="WelcomePanel">
			<h1>
				Tabbl App
			</h1>
			<h4>
				Collaboratively view and edit board game scores!
			</h4>
			<br/>
			<p>Connect to Match</p>
			<form onSubmit={onConnectFormSubmit}>
				<input disabled={isStartingGame} value={matchId} onChange={e => setMatchId(e.target.value)}/>
				<button disabled={isStartingGame} type="submit">
					Submit
				</button>
			</form>
			<br/>
			<p>Create New Match</p>
			<button disabled={isStartingGame} onClick={onCreateGameSubmit}>
				{isStartingGame ? "Starting..." : "Create New Match"}
			</button>
		</div>
	)
}